/*
Change Y axis on scroll
 */
function initScrollingText() {
    scrollWordText       = scrollWord.find('text');
    scrollWordScrollX    = 0;
    scrollWordMaxScrollX = window.innerWidth * 2;
    requestAnimationFrame(scrollHomepageWord);
    var tween = new TimelineMax()
        .add([
            TweenMax.fromTo(".scrolling-text svg text", 1, {attr:{y: '50%'}}, {attr:{y: '70%'}})
        ]);

    new ScrollMagic.Scene({triggerElement: ".scrolling-text", duration: $(window).height()})
        .setTween(tween)
        .addTo(scrollController);

    resizeScrollingText();
}

/*
Resize animated SVG to match window width
 */
function resizeScrollingText(){
    var windowWidth = $(window).width();
    scrollWord.attr('width', windowWidth + 'px');
    scrollWord[0].setAttribute('viewBox', '0 0 ' + windowWidth + ' 600');
    scrollWord.attr('height', '600px');
    scrollWord.find('image').attr('width', windowWidth + 'px').attr('height', '600px');
    scrollWordMaxScrollX = window.innerWidth * 2;
}

/*
Text Go from right to left
 */
function scrollHomepageWord() {
    scrollWordScrollX = scrollWordScrollX - 2;
    if(scrollWordScrollX <= -scrollWordMaxScrollX * 2){
        scrollWordScrollX = -scrollWordMaxScrollX + 12;
    }
    scrollWordText.attr('transform','matrix(1,0,0,1,' + scrollWordScrollX + ',0)');
    requestAnimationFrame(scrollHomepageWord);
}
